import { CopyPropsI } from "./Copy.props";
import { CopyToClipboard } from "react-copy-to-clipboard";
import Icon from "../Icon/Icon";

import origCopy from "@assets/redesign/icons/copy.svg";
import wlpCopy from "@components/WLP202603/assets/redesign/icons/copy.svg";
import { makeNotifs } from "@utils/makeNotifs";
import { useGlobalNotifs } from "@utils/hooks/useGlobalNotifs";
import { WLP202603 } from "../../../../config";

const copy = WLP202603 ? wlpCopy : origCopy;

export default function Copy({
  text,
  icon = copy,
  className,
  size,
  children,
}: CopyPropsI) {
  const { ok } = makeNotifs();
  const { onSuccess } = useGlobalNotifs();

  return (
    <CopyToClipboard
      text={text}
      onCopy={(e) => {
        onSuccess(ok.copied);
      }}
    >
      {children ? (
        children
      ) : (
        <Icon
          src={icon}
          className={className}
          style={{ width: size, height: size }}
          onClick={(e) => e.stopPropagation()}
        />
      )}
    </CopyToClipboard>
  );
}
